import { generateTypes } from '../../utils/HttpReducerHelper';

export const makeChampion = generateTypes('TEAMS', 'MAKE_CHAMPION');
export const OPEN_MAKE_CHAMPION_MODAL = 'platfi-ui-app/TEAMS/OPEN_MAKE_CHAMPION_MODAL';
export const CLOSE_MAKE_CHAMPION_MODAL = 'platfi-ui-app/TEAMS/CLOSE_MAKE_CHAMPION_MODAL';
